import type {InvoiceSerializer} from "@/generated/DjangoTypes";
import {useSettingsCompanyStore} from "@/store/company";
import type {TSettingsScope} from "@/store/types";
import useUserStore from "@/store/user";

export const usePaymentFailedInvoices = () => {
  const failedInvoices = useUserStore(state => state.user.payment_failed_invoices);
  const scopeCompany = useSettingsCompanyStore(state => state.company);

  const getPaymentFailedInvoices = ({scope}: {scope: TSettingsScope}): InvoiceSerializer[] =>
    scope.type === "brand" && scopeCompany.id === scope.id
      ? (scopeCompany.payment_failed_invoices ?? [])
      : (failedInvoices ?? []).filter(invoice =>
          scope.type === "agency" ? invoice.agency === scope.id : invoice.company_profile?.id === scope.id,
        );

  return {getPaymentFailedInvoices};
};
